import {Modal, Button, ModalHeader, ModalBody, ModalTitle, ModalFooter} from "react-bootstrap";
import SignInForm from "./SignInModalContent/SignInForm";
import {SeasonModel, SignInUserToASeasonModel} from "../../features/season/seasonTypes";


type Props = {
    season?: SeasonModel,
    showModal: boolean,
    setShowModal: (showModal: boolean) => void,
    setSelectedCarId: (id: number | 0) => void,
    selectedCarId: number | 0
    onSubmit: (data: SignInUserToASeasonModel) => void;
};

const SignInModal = ({season, showModal, setShowModal, selectedCarId, setSelectedCarId, onSubmit}: Props) => {

    if(!season){
        return <></>
    }
    return (
        <>
            <Modal
                show={showModal}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <ModalHeader closeButton>
                    <ModalTitle id="contained-modal-title-vcenter">
                        Sign In
                    </ModalTitle>
                </ModalHeader>
                <ModalBody>
                    <>
                        <SignInForm season={season}
                                    selectedCarId={selectedCarId}
                                    setSelectedCarId={setSelectedCarId}
                                    onSubmit={onSubmit}
                        />
                    </>
                </ModalBody>
                <ModalFooter>
                    <Button className={`p-1`} onClick={() => setShowModal(false)}>
                        Close
                    </Button>
                    <Button className={`p-1`} type="submit">
                        Sign Up
                    </Button>
                </ModalFooter>
            </Modal>
        </>
    );
};
export default SignInModal;
